module.exports = __webpack_public_path__ + "static/LucasPope3-9a010718ab2b57c5831b658b83f45a0a.webp";